import React, { useState } from "react";
import axios from "axios";
import { useNavigate } from "react-router-dom";
const API_BASE_URL = window.location.origin; 

const AuthPage = () => {
  const navigate = useNavigate();
  const [activeCard, setActiveCard] = useState("login"); // Default to Login card
  const [username, setUsername] = useState("");
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");

  const handleLogin = async (e) => {
    e.preventDefault();
    try {
      const response = await axios.post(`${API_BASE_URL}/api/login/`, { username, password });

      const { access, refresh, username: returnedUsername } = response.data;
  
      localStorage.setItem("username", returnedUsername || username);
      localStorage.setItem("access_token", access);
      localStorage.setItem("refresh_token", refresh);
  
      navigate("/user");
    } catch (error) {
      alert(error.response?.data?.error || "An error occurred");
    }
  };
  

  const handleRegister = async (e) => {
    e.preventDefault();
    try {
      const response = await axios.post(`${API_BASE_URL}/api/register/`, { username, email, password });

      alert(response.data.message);
      navigate("/check-email"); // Redirect to the Check Email page
    } catch (error) {
      alert(error.response?.data?.error || "An error occurred");
    }
  };

  const handleGuestLogin = async () => {
    try {
      const response = await axios.post(`${API_BASE_URL}/api/guest-login/`);
      const { username, access, refresh } = response.data;
  
      localStorage.setItem("username", username);
      localStorage.setItem("access_token", access);
      localStorage.setItem("refresh_token", refresh);
  
      alert(`You are logged in as ${username}`);
      navigate("/user");
    } catch (error) {
      alert(error.response?.data?.error || "An error occurred during guest login");
    }
  };
  
  const handleOAuthLogin = (provider) => {
      window.location.href = `${API_BASE_URL}/api/auth/${provider}/login`;
  };

  return (
    <div className="auth-page bg-gray-100 dark:bg-gray-900 min-h-screen flex flex-col justify-center items-center">
      <div className="inline-flex rounded-md shadow-sm mb-6" role="group">
        <button
          onClick={() => setActiveCard("login")}
          className={`inline-flex items-center px-4 py-2 text-sm font-medium ${
            activeCard === "login"
              ? "text-white bg-gray-700"
              : "text-gray-900 bg-transparent border border-gray-900"
          } rounded-l-lg hover:bg-gray-900 hover:text-white dark:border-white dark:hover:bg-gray-700 dark:text-white`}
        >
          <svg className="w-4 h-4 mr-2" fill="currentColor" viewBox="0 0 20 20">
            <path d="M10 0a10 10 0 1 0 10 10A10.011 10.011 0 0 0 10 0Zm0 5a3 3 0 1 1 0 6 3 3 0 0 1 0-6Zm0 13a8.949 8.949 0 0 1-4.951-1.488A3.987 3.987 0 0 1 9 13h2a3.987 3.987 0 0 1 3.951 3.512A8.949 8.949 0 0 1 10 18Z" />
          </svg>
          Login
        </button>
        <button
          onClick={() => setActiveCard("register")}
          className={`inline-flex items-center px-4 py-2 text-sm font-medium ${
            activeCard === "register"
              ? "text-white bg-gray-700"
              : "text-gray-900 bg-transparent border-t border-b border-gray-900"
          } hover:bg-gray-900 hover:text-white dark:border-white dark:hover:bg-gray-700 dark:text-white`}
        >
          <svg class="w-4 h-4 mr-2" fill="currentColor" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24">
            <path d="M14.69,3.26a3.67,3.67,0,0,1,5.2,5.2L8.29,20.07a1,1,0,0,1-.51.27l-5,1a1,1,0,0,1-1.15-1.15l1-5a1,1,0,0,1,.27-.51ZM16.1,9,15,7.93l-9.14,9.14-.35,1.77,1.77-.35ZM17.51,7.6l.84-.84a1.67,1.67,0,0,0-2.36-2.36l-.84.84Z"/>
          </svg>
          Register
        </button>
        <button
          onClick={() => setActiveCard("guest")}
          className={`inline-flex items-center px-4 py-2 text-sm font-medium ${
            activeCard === "guest"
              ? "text-white bg-gray-700"
              : "text-gray-900 bg-transparent border border-gray-900"
          } rounded-r-lg hover:bg-gray-900 hover:text-white dark:border-white dark:hover:bg-gray-700 dark:text-white`}
        >
          <svg class="w-4 h-4 mr-2" fill="currentColor" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24">
            <path d="M21,9a1,1,0,0,0,1-1V5a1,1,0,0,0-1-1H3A1,1,0,0,0,2,5V8a1,1,0,0,0,1,1H4.6l.94,8.43A5,5,0,0,0,10.5,21h3a5,5,0,0,0,5-3.53L19.4,9ZM4,6H20V8H4ZM17.46,16.25A3,3,0,0,1,13.5,19h-3a3,3,0,0,1-3-2.75L6.6,9H17.4Z"/>
          </svg>
          Guest
        </button>
      </div>

      {/* Cards */}
      <div className="bg-white dark:bg-gray-800 p-8 rounded shadow-md w-96 min-h-[500px] flex flex-col justify-center">
        {activeCard === "login" && (
          <form onSubmit={handleLogin}>
            <h2 className="text-2xl font-bold text-center mb-4 text-gray-900 dark:text-white">
              Login
            </h2>
            <div className="mb-4">
              <label className="block text-gray-700 dark:text-gray-300 mb-2">Username:</label>
              <input
                type="text"
                className="w-full px-4 py-2 border rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500 dark:bg-gray-700 dark:border-gray-600 dark:text-white"
                value={username}
                onChange={(e) => setUsername(e.target.value)}
                required
              />
            </div>
            <div className="mb-4">
              <label className="block text-gray-700 dark:text-gray-300 mb-2">Password:</label>
              <input
                type="password"
                className="w-full px-4 py-2 border rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500 dark:bg-gray-700 dark:border-gray-600 dark:text-white"
                value={password}
                onChange={(e) => setPassword(e.target.value)}
                required
              />
            </div>
            <button
              type="submit"
              className="w-full bg-blue-600 text-white py-2 rounded-md hover:bg-blue-700 focus:outline-none focus:ring-2 focus:ring-blue-500"
            >
              Login
            </button>
          </form>
        )}

        {activeCard === "register" && (
          <form onSubmit={handleRegister}>
            <h2 className="text-2xl font-bold text-center mb-4 text-gray-900 dark:text-white">
              Register
            </h2>
            <div className="mb-4">
              <label className="block text-gray-700 dark:text-gray-300 mb-2">Username:</label>
              <input
                type="text"
                className="w-full px-4 py-2 border rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500 dark:bg-gray-700 dark:border-gray-600 dark:text-white"
                value={username}
                onChange={(e) => setUsername(e.target.value)}
                required
              />
            </div>
            <div className="mb-4">
              <label className="block text-gray-700 dark:text-gray-300 mb-2">Email:</label>
              <input
                type="email"
                className="w-full px-4 py-2 border rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500 dark:bg-gray-700 dark:border-gray-600 dark:text-white"
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                required
              />
            </div>
            <div className="mb-4">
              <label className="block text-gray-700 dark:text-gray-300 mb-2">Password:</label>
              <input
                type="password"
                className="w-full px-4 py-2 border rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500 dark:bg-gray-700 dark:border-gray-600 dark:text-white"
                value={password}
                onChange={(e) => setPassword(e.target.value)}
                required
              />
            </div>
            <button
              type="submit"
              className="w-full bg-blue-600 text-white py-2 rounded-md hover:bg-blue-700 focus:outline-none focus:ring-2 focus:ring-blue-500"
            >
              Register
            </button>
          </form>
        )}

        {activeCard === "guest" && (
          <div>
            <h2 className="text-2xl font-bold text-center mb-4 text-gray-900 dark:text-white">
              Guest Login
            </h2>
            <p className="text-gray-700 dark:text-gray-300 mb-6 text-center">
              Log in as a guest to explore the website without creating an account.
            </p>
            <button
              onClick={handleGuestLogin}
              className="w-full bg-blue-600 text-white py-2 rounded-md hover:bg-blue-700 focus:outline-none focus:ring-2 focus:ring-blue-500"
            >
              Guest Login
            </button>
          </div>
        )}
        <div className="flex gap-4 mt-6 min-w-fit">
        <button
          onClick={() => handleOAuthLogin("google")}
          className="flex min-w-24 items-center justify-center w-full max-w-xs px-4 py-2 bg-gray-900 text-white font-medium text-sm rounded-lg shadow-md hover:bg-gray-700 focus:outline-none focus:ring-2 focus:ring-red-500 focus:ring-offset-1 transition-all duration-150"
        >
          <img
            src="https://www.svgrepo.com/show/475656/google-color.svg"
            alt="Google"
            className="w-6 h-6 mr-3"
          />
        </button>

        <button
          onClick={() => handleOAuthLogin("github")}
          className="flex min-w-24 items-center justify-center w-full max-w-xs px-4 py-2 bg-gray-900 text-white font-medium text-sm rounded-lg shadow-md hover:bg-gray-700 focus:outline-none focus:ring-2 focus:ring-gray-700 focus:ring-offset-1 transition-all duration-150"
        >
          <img
            src="https://www.svgrepo.com/show/475654/github-color.svg"
            alt="github"
            className="w-6 h-6 mr-3"
          />
        </button>
      </div>
      </div>

      {/* Go Back Button */}
      <button
        onClick={() => navigate("/")}
        className="mt-6 bg-gray-600 text-white px-6 py-2 rounded-md hover:bg-gray-700 focus:outline-none focus:ring-2 focus:ring-gray-500"
      >
        Go Back to Homepage
      </button>
    </div>
  );
};

export default AuthPage;
